import { ProductCatalogResponse } from '@/types/productCatalog';
import { create } from 'zustand';

interface ProductCatalogState {
  products: ProductCatalogResponse | null;
  searchQuery: string;
  currentPage: number;
  setProducts: (products: ProductCatalogResponse) => void;
  setSearchQuery: (query: string) => void;
  setCurrentPage: (page: number) => void;
}

export const useProductCatalogStore = create<ProductCatalogState>((set) => ({
  products: null,
  searchQuery: '',
  currentPage: 1,
  setProducts: (products) => set({ products }),
  setSearchQuery: (query) => set({ searchQuery: query, currentPage: 1 }),
  setCurrentPage: (page) => set({ currentPage: page }),
}));
